"use client"

import { createContext, useContext, useState, useEffect, ReactNode } from "react"

interface AuthFlowContextType {
  isInCriticalFlow: boolean
  startCriticalFlow: () => void
  endCriticalFlow: () => void
}

const AuthFlowContext = createContext<AuthFlowContextType>({
  isInCriticalFlow: false,
  startCriticalFlow: () => {},
  endCriticalFlow: () => {},
})

export function AuthFlowProvider({ children }: { children: ReactNode }) {
  const [isInCriticalFlow, setIsInCriticalFlow] = useState(false)

  // Initialize from sessionStorage on mount
  useEffect(() => {
    if (typeof window !== "undefined") {
      const saved = sessionStorage.getItem("auth-critical-flow")
      if (saved === "true") {
        setIsInCriticalFlow(true)
      }
    }
  }, [])

  const startCriticalFlow = () => {
    setIsInCriticalFlow(true)
    if (typeof window !== "undefined") {
      sessionStorage.setItem("auth-critical-flow", "true")
    }
  }

  const endCriticalFlow = () => {
    setIsInCriticalFlow(false)
    if (typeof window !== "undefined") {
      sessionStorage.removeItem("auth-critical-flow")
    }
  }

  return (
    <AuthFlowContext.Provider
      value={{ isInCriticalFlow, startCriticalFlow, endCriticalFlow }}
    >
      {children}
    </AuthFlowContext.Provider>
  )
}

export function useAuthFlow() {
  return useContext(AuthFlowContext)
}

// Helper for non-React contexts
export function isInCriticalAuthFlow(): boolean {
  if (typeof window === "undefined") return false
  return sessionStorage.getItem("auth-critical-flow") === "true"
}
